import Select from 'ol/interaction/Select';
import {click} from 'ol/events/condition';

export default function({popupInst, layers, styleActive, selectFeature}){

	var selectInteraction = new Select({
        style: styleActive,
    /*    filter: function(feature, layer){
        	return layer.getProperties().group === 'schools';
        },*/
        layers: layers,
        multi: false,
        condition: click,
    /*    condition: function(event) {

        	if(event.dragging)  {
        		return;
        	}

        	if(event.type !== 'singleclick'
        	//	&& event.type !== ol.MapBrowserEventType.POINTERMOVE
        		){


                event.preventDefault();
        		//return false;
        	} else {
                return true;
            }

        //	selectInteraction.getFeatures().clear();
        }*/});

        selectInteraction.getFeatures().on(['add','remove'], function(e) {
                console.log('INTERACTION INTENSITY', selectInteraction.getFeatures());

                var selectedFeatures = selectInteraction.getFeatures().getArray();

                selectFeature(selectedFeatures);

                if(selectedFeatures.length == 0) {
               //         popup.setPosition(undefined);
                //      StudentsState.setActiveSchool(null);
                   

                   popupInst.setPosition(undefined);
                       
                } else {
                        
                   //     state.selectEvent(selectedFeatures[0].getProperties());

                        var lastPos = selectedFeatures[0].getGeometry().getLastCoordinate();
                        var firstPos = selectedFeatures[0].getGeometry().getFirstCoordinate();
                        if(lastPos[1] > firstPos[1]){
                            var position = lastPos;
                        } else {
                            var position = firstPos;
                        }

                        popupInst.setPosition(position);
                  //       mapState.popup.setPosition(selectedFeatures[0].getGeometry().getFirstCoordinate());
                //        selectFeature({feature: selectInteraction.getFeatures().getArray()[0], mousePos: mousePos, map: map});
                }

        });

        
		selectInteraction.disableInteraction = function() {

            //var activeLayer = state.getActiveGroup();
             //   if(!activeLayer) {
                    
            selectInteraction.getFeatures().clear();
            popupInst.setPosition(undefined);
            //    }
        }
		
        return selectInteraction;
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mobility/interaction.js